export default "__VITE_ASSET__Cp99AiYw__"